<template>
  <div class="card h-100 error-fallback-widget">
    <div class="card-header d-flex align-items-center">
      <!-- <p class="mx-5 mt-5">Error in widget with id {{ id }}</p> -->
      <h4 ref="title" class="card-title d-flex align-items-center">
        <i class="bi bi-exclamation-circle-fill fs-2 me-3 text-danger"></i>
        {{ $t('widgetErrorFallback.title', { id }) }}
      </h4>
    </div>
    <div class="card-body">
      <p>
        {{ $t('widgetErrorFallback.description') }}
      </p>
      <div class="d-flex gap-4">
        <button class="btn btn-sm btn-secondary btn-sm mb-3" @click="reload">
          <i class="bi bi-arrow-clockwise fs-2 me-3"></i>
          {{ $t('resultsmessages.reload') }}
        </button>
        <button class="btn btn-sm btn-secondary btn-sm mb-3" @click="report">
          <i class="bi bi-envelope fs-3 me-2"></i>
          {{ $t('resultsmessages.report') }}
        </button>
      </div>

      <button class="btn btn-link" @click="toggleDetails">
        {{
          showDetails
            ? $t('widgetErrorFallback.hideErrorDetails')
            : $t('widgetErrorFallback.showErrorDetails')
        }}
      </button>
      <!-- Collapsible error details -->
      <div v-if="showDetails" class="alert alert-danger error-details">
        <pre>

          {{ error }}
        </pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorFallbackWidget',
  props: {
    id: {
      type: String,
      default: 'error-fallback-widget'
    },
    error: {
      type: Object,
      default: () => {}
    },
    surveyDetails: {
      type: Object,
      default: () => {}
    },
    organizationName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDetails: false
    }
  },
  methods: {
    reload() {
      window.location.reload()
    },
    report() {
      console.error(this.error)
      // window.location.href = 'mailto:support@puls-solutions.se'
      const subject = encodeURIComponent(`Error Report`)
      const body = encodeURIComponent(
        `Survey ${this.surveyDetails.name} in organization ${this.organizationName}\n
Error Details:\n${JSON.stringify(this.error, null, 2)}`
      )
      const mailtoLink = `mailto:support@puls-solutions.se?subject=${subject}&body=${body}`
      // Using window.location.href to trigger the mailto action
      window.open(mailtoLink, '_blank')
      // window.location.href = mailtoLink
    },
    toggleDetails() {
      this.showDetails = !this.showDetails
    }
  }
}
</script>

<style scoped>
.error-fallback-widget {
  border: 2px dashed red;
}
</style>
